import { render, staticRenderFns } from "./LottieWrapper.vue?vue&type=template&id=44d76289&"
import script from "./LottieWrapper.vue?vue&type=script&lang=js&"
export * from "./LottieWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports